import { QuestionMark } from "assets/images";
import { FC, useState } from "react";
import Lottie from "react-lottie-player";
import { IPropsTrackerSettingsModal } from "types/modal/TypeModal";
import OverlayModalCommon from "utils/settingsModal/common/OverLayModalCommon";
import lottieJson from "assets/gifs/dottedBtn.json";
import SendCommand from "hooks/SendCommand";
import { ToastDanger } from "utils/toast/Toast";

const CustomCommandModal: FC<IPropsTrackerSettingsModal> = ({
  online,
  imei,
  onClose,
  open,
  sendSms,
}) => {
  const [commands, setCommands] = useState("");

  const [value, setValue] = useState<string>("");
  const [trigger, setTrigger] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleValues = (data: string) => {
    if (data) {
      setValue(data);
    }
  };

  const [CustomCommand, setCustomCommand] = useState("");

  const onSubmit = () => {
    if (CustomCommand) {
      setCommands(CustomCommand);
      setValue("");
      setTrigger(trigger + 1);
    } else {
      ToastDanger("لطفا دستور مورد نظر را وارد کنید");
    }
  };

  const closeModal = () => {
    setTrigger(0);
    setValue("");
    setCommands("");
    setIsLoading(false);
    setCustomCommand("");
    onClose();
  };

  return (
    <OverlayModalCommon onClose={closeModal} open={open}>
      <div className="contentModalSettingsCustomMap scrollbar-div">
        <SendCommand
          online={online}
          command={commands}
          imei={imei ? imei.toString() : ""}
          name={"دستور دستی"}
          trigger={trigger}
          setIsLoading={setIsLoading}
          handleValues={handleValues}
          open={open}
          sendSms={sendSms}
        />
        <div className="rowheaderModalSettingTracker">
          <div className="trackerSettingModalHeaderRight">
            <div onClick={closeModal} className="icon3-close pointer" />
            <div className="titleheaderModal">دستور دستی</div>
          </div>
          <div className="trackerSettingModalLeft">
            <img
              src={QuestionMark}
              alt={"logo"}
              className="trackerSettingModalLeftLogo"
            />
          </div>
        </div>

        {value ? (
          <div className="rowBodyModalSuccess">
            <>
              <div style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
                پاسخ :
              </div>
              <div className="oneClickModalValueContainer">{value}</div>
            </>

            <div className="titleSuccessModal">
              {isLoading ? "در انتظار پاسخ" : value ? "" : ""}
            </div>
          </div>
        ) : null}

        <div className="rowBodyModalSettingMap">
          <div className="lableAbsoluteOption">دستور را وارد کنید</div>
          <input
            style={{ direction: "ltr" }}
            value={CustomCommand}
            onChange={(e) => setCustomCommand(e.target.value)}
            className="containerInpuSettingsMap"
          />
        </div>

        <div className="rowBtnSettingsMap">
          {!isLoading ? (
            <>
              <div
                onClick={onSubmit}
                className="BtnSettingsMapSubmit pointer pointer"
              >
                ثبت
              </div>
              <div
                onClick={closeModal}
                className="BtnSettingsMapCancel pointer pointer"
              >
                انصراف
              </div>
            </>
          ) : (
            <div className="containerLottieDoted">
              <Lottie
                loop
                animationData={lottieJson}
                play
                className="dotedLottie"
              />
            </div>
          )}
        </div>
      </div>
    </OverlayModalCommon>
  );
};
export default CustomCommandModal;
